export class HaltedRequestModel {
    public symbol = '';
}